import React from 'react';
import SEOHead from '../components/SEOHead';

const TICKET_LINKS = [
  { name: 'StubHub', url: 'https://www.stubhub.com' },
  { name: 'SeatGeek', url: 'https://www.seatgeek.com' },
  { name: 'Ticketmaster', url: 'https://www.ticketmaster.com' },
];

const Tickets = () => (
  <>
    <SEOHead
      title="World Cup 2026 Tickets - WorldCup Fan Planner"
      description="Official partner links to find FIFA World Cup 2026 tickets and resale options. Compare trusted ticket providers."
    />
  <div className="max-w-7xl mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Tickets</h1>
    <p className="text-gray-600 dark:text-gray-400 mb-6">Find tickets for 2026 FIFA World Cup matches via our partners.</p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {TICKET_LINKS.map((t) => (
        <a key={t.name} href={t.url} target="_blank" rel="noopener noreferrer" className="p-4 rounded-lg bg-white dark:bg-gray-800 shadow dark:shadow-gray-900 border dark:border-gray-700 hover:ring-2 hover:ring-amber-500">
          {t.name}
        </a>
      ))}
    </div>
  </div>
  </>
);

export default Tickets;
